import { render } from "./CreateStoreProduct.vue?vue&type=template&id=69cd68f4"
import script from "./CreateStoreProduct.vue?vue&type=script&lang=js"
export * from "./CreateStoreProduct.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/medicalmobile-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__